import templateUrl from './process-tax-notice-dashboard.component.html';

export const ProcessTaxNoticeDashboardComponent = {
    templateUrl,
    controller: ProcessTaxNoticeDashboardController,
    controllerAs: "vm",
};

function ProcessTaxNoticeDashboardController(taxNoticeService, employeeService, utilityService) {
    'ngInject';
    const vm = this;
    vm.toggle = toggle;
    vm.isManager = false;
    vm.$onInit = function () {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                taxNoticeService.getUserRole(result.UserName)
                    .then(function (usrRole) {
                        console.log(usrRole);
                        if (usrRole === 'Manager') {
                            vm.isManager = true;
                        }
                        utilityService.hideLoading();
                    })
                return result;
            })
            .catch((err) => {
                console.log(err);
            })
    };
    function toggle(document: any, description: string) {
        if (document.Description !== description) {
            taxNoticeService.updateDescription({
                TaxNoticeDocumentId: document.NoticeDocumentId,
                Text: description
            }).then(function (result) {
            }).catch(function (ex) {
                console.log('Change failed');
            });
        }
    }
}

